var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"mouseover":_vm.playVideo,"mouseout":_vm.stopVideo}},[_c('youtube',{ref:"youtube",staticClass:"video",attrs:{"video-id":_vm.youtube,"playerVars":{'rel': 0, 'showinfo': 0}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }